import type { SimulatorChannel } from '@/backendApis';
import {
  type MessagingChannelType,
  MessagingChannelTypes,
} from '@/features/msg-channels/common/msg-channels.types';

export const SIMULATOR_CHANNELS: SimulatorChannel[] = ['imessage', 'whatsapp'];

export const SIMULATOR_CHANNEL_LABELS: Record<SimulatorChannel, string> = {
  imessage: 'iMessage',
  whatsapp: 'WhatsApp',
};

export const SIMULATOR_CHANNEL_TYPES: Record<
  SimulatorChannel,
  MessagingChannelType
> = {
  imessage: MessagingChannelTypes.IMESSAGE,
  whatsapp: MessagingChannelTypes.WHATSAPP_BUSINESS,
};
